import React, { Component } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import Modal from 'react-responsive-modal';
import { InputText } from 'primereact/inputtext';
import { ToastContainer, toast } from 'react-toastify';
import Input from '../../../Comman/components/Input';
import { confirmAlert } from 'react-confirm-alert'; 
import 'react-toastify/dist/ReactToastify.css';
import {baseUrl} from '../../../Comman/apiEndPoints';
import swal from 'sweetalert';
import { withNamespaces } from 'react-i18next';

const sleep = (milliseconds) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds))
}
class RejectedHeartRunnerComponent extends Component {
    constructor(props) {
        super(props)
        this.state = {
            viewDetailModal : false,
            isProfile:false,
            RegionId:'',
        };
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.rejectedHeartRunnerList.message !== this.props.rejectedHeartRunnerList.message) {
            if(nextProps.rejectedHeartRunnerList.statusCode == 200){                
                swal(nextProps.rejectedHeartRunnerList.message)
            }
        }
    }
    notify = (message) => {
        this.toastId =toast.success(message, {
            position: toast.POSITION.TOP_CENTER
        });
    }
      changeRegion = (e) => {
        let value = e.target.value;
        let payload = {
            RegionId: value,
        }
        this.state.RegionId = value.toString();
        this.setState({ RegionId: value.toString() });

        this.props.getUserList(payload)

        // sleep(3000).then(() => {
        //     console.log("setstate",this.state);
        // })
    }
    viewDeleteAction = (rowData) =>{
        const { t } = this.props;
        return(
            <div>
                <span className="enable-cursor delbtn" onClick={() => { this.openViewModal(rowData) }} title={t('First_Responder.View')}><i className="fa fa-eye"></i></span>
                <span className="enable-cursor delbtn" onClick={() => { this.deleteItem(rowData.UserId) }} title={t("First_Responder.Delete")}><i className="fa fa-lg fa-trash" aria-hidden="true"></i></span>
                <span className="enable-cursor delbtn" onClick={() => { this.approve(rowData) }} title={t('First_Responder.Approve')}><i className="fa fa-thumbs-up" aria-hidden="true"></i></span>
            </div>
        )
    }
    approve = (rowData) =>{
        let requestPayload = {
            UserId : rowData.UserId
        }
        this.props.onApprove(requestPayload,this.state.RegionId == '' ? (this.props.rejectedHeartRunnerList.regionList.length > 0 ? this.props.rejectedHeartRunnerList.regionList[0].ID : null) : this.state.RegionId);
    }
    openViewModal=(rowData)=> {
        this.setState({ viewDetailModal : true }) 
        sleep(500).then(() => {
            document.getElementById("fName").value = rowData.FirstName ? rowData.FirstName : '';
            document.getElementById("lName").value = rowData.LastName ? rowData.LastName : '';
            document.getElementById("Email").value = rowData.EmailId ? rowData.EmailId : '';
            document.getElementById("PhoneNumber").value = rowData.Phone ? rowData.Phone : '';
            // document.getElementById("CertificateId").value = rowData.CertificateId ? rowData.CertificateId : '';
            document.getElementById("WorkingPlace").value = rowData.WorkingPlace ? rowData.WorkingPlace : '';
            document.getElementById("Proffession").value = rowData.Proffession ? rowData.Proffession : '';
            document.getElementById("CPREducation").value = rowData.CPREducation ? rowData.CPREducation : '';
             document.getElementById("RegionName").value = rowData.RegionName ? rowData.RegionName: '';
        })
        this.setState({isProfile : (rowData.Image ? true : false)})
        sleep(500).then(() => {
            if(rowData.Image){
                document.getElementById("profile-img-src").src = baseUrl + rowData.Image;
            }
            else{
                var nameInitials = rowData.FirstName.charAt(0).toUpperCase() + rowData.LastName.charAt(0).toUpperCase();
                document.getElementById("name-initials").innerHTML =  nameInitials;
            }
        })   
    }
    closeViewModal = () => {
        this.setState({ viewDetailModal: false })
    }
    deleteItem(id) {
        const { t } = this.props;
        confirmAlert({
            title: `${t('First_Responder.Confirm to delete')}`,
            message: `${t('First_Responder.Are you sure to delete this?')}`,
            buttons: [
              {
                label: `${t('First_Responder.Yes')}`,
                onClick: () => {
                    let requestPayload = {
                        UserId : id
                    };
                    this.props.onDelete(requestPayload,this.state.RegionId == '' ? (this.props.rejectedHeartRunnerList.regionList.length > 0 ? this.props.rejectedHeartRunnerList.regionList[0].ID : null) : this.state.RegionId);
                }
              },
              {
                label: `${t('First_Responder.No')}`,
                onClick: () => {
                }
              }
            ]
          });
    }
    render() {
        const { t } = this.props;
        console.log("props",this.props);
        var header = <div className="search-name">
                        <i className="fa fa-search" style={{ margin: '4px 4px 0 0' }}></i>
                        <InputText type="text" onInput={(e) => this.setState({ globalFilter: e.target.value })} placeholder={t('First_Responder.Search')} size="50" />
                    </div>;
                    let  regionListOption; 
      let regionList=this.props.rejectedHeartRunnerList.regionList;
      if(regionList){
          regionListOption = regionList.map((item) =>
                <option style={{background : '#f5f1f1'}} value={item.ID} key={item.ID}>{item.RegionName}</option>
            );
        }
        return (
            <div>
                <div className="progressbar-heading grids-heading">
                    <h2>{t('First_Responder.Rejected First Responder')}</h2>
                </div>
                <ToastContainer />
                <div className=" forms-panel w3-last-form">
                    <div className="forms add-device">
                        <div className="form-three widget-shadow">
                            <div className=" panel-body-inputin">
                                 <div className="text-left m-b-25 ">


                                    <select id="regionData" style={{ fontSize: 'large', padding: '7px' }}
                                        onChange={this.changeRegion}
                                        placeholder="Select"
                                        ref="regionData"
                                        name={'RegionId'}
                                    >
                                        {regionListOption}
                                    </select>
                                </div>
                                <div className="w3l_search">
                                    {header}
                                </div>
                                <div className="devicestable">
                                    <br />
                                    <DataTable
                                        className="table"
                                        value={this.props.rejectedHeartRunnerList.rejectedHeartRunnerList}
                                        loading={this.props.rejectedHeartRunnerList.isLoading}
                                        paginator={true} rows={10}
                                        globalFilter={this.state.globalFilter}
                                        emptyMessage={t('First_Responder.No records found')}
                                    >
                                        <Column field="UserId" header="" className="noDisplay" />
                                        <Column sortable={true} field="FirstName" header={t('First_Responder.First Name')}  />
                                        <Column sortable={true} field="LastName" header={t('First_Responder.Last Name')} /> 
                                        <Column sortable={true} field="EmailId" className="wordBreakLine" header={t('First_Responder.Email')} />
                                        <Column sortable={true} field="Phone" header={t('First_Responder.Phone Number')} />
                                        {/* <Column sortable={true} field="CertificateId" header={t('First_Responder.Certification ID')} /> */}
                                        <Column header={t('First_Responder.Action')}  body={this.viewDeleteAction} />
                                    </DataTable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Modal open={this.state.viewDetailModal}  onClose={this.closeViewModal} center> 
                    <div className="modal1 alarmsetmodal viewReponder">
                        <div className="progressbar-heading grids-heading">
                            <h2>{t('First_Responder.View First Responder Information')}</h2>
                        </div>
                            <div className="profile-dp">
                            { this.state.isProfile ? 
                                    <img className="profile-img" id="profile-img-src" src="" alt="" /> 
                                :
                                    <div id="name-initials"></div>
                            }
                            </div>
                            <form className="form-horizontal">
                                <Input 
                                   type={'text'}
                                   title= {t('First_Responder.First Name')} 
                                   name= {'FirstName'}
                                   placeholder = {t('First_Responder.Enter First Name')}
                                   icon="fa fa-user"
                                   id="fName"
                                   readOnly
                                                                  
                                /> {/* Name of the user */}
                                <Input 
                                   type={'text'}
                                   title= {t('First_Responder.Last Name')} 
                                   name= {'LastName'}
                                   placeholder = {t('First_Responder.Enter Last Name')}
                                   icon="fa fa-user"
                                   id="lName"
                                   readOnly
                                /> {/* Name of the user */}
                                <Input 
                                   type={'text'}
                                   icon="fa fa-envelope"
                                   title= {t('First_Responder.Email ID')}
                                   id="Email"
                                   readOnly
                                /> {/* Name of the user */}
                                <Input 
                                   type={'text'}
                                   title= {t('First_Responder.Phone Number')}
                                   icon="fa fa-phone"
                                   id="PhoneNumber"
                                   readOnly
                                /> {/* Name of the user */}
                                    <Input 
                                                                   type={'text'}
                                                                   title= {'Region'} 
                                                                   icon="fa fa-area-chart"
                                                                   id="RegionName"
                                                                   readOnly
                                                                /> {/* Name of the user */}
                                {/* <Input 
                                   type={'text'}
                                   title= {t('First_Responder.Certification ID')}
                                   icon="fa fa-certificate"
                                   id="CertificateId"
                                   readOnly
                                /> */}
                                <Input 
                                   type={'text'}
                                   title= {t('First_Responder.CPREducation')} 
                                   icon=""
                                   id="CPREducation"
                                   readOnly
                                />
                                <Input 
                                   type={'text'}
                                   title= {t('First_Responder.Proffession')} 
                                   icon=""
                                   id="Proffession"
                                   readOnly
                                />
                                <Input 
                                   type={'text'}
                                   title= {t('First_Responder.WorkingPlace')}
                                   icon=""
                                   id="WorkingPlace"
                                   readOnly
                                />
                                
                           </form> 
                        </div>
                </Modal>
            </div>
        )
    }
}
export default withNamespaces()(RejectedHeartRunnerComponent);